// extracted by mini-css-extract-plugin
module.exports = {"rolling":"rolling-item_rolling__1Uoa9","inner":"rolling-item_inner__2FpXf","box":"rolling-item_box__QwRFF"};